import Box from '@mui/material/Box'
import { styled } from '@mui/system'

const CoachOverviewActiveLabelBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: '0.25rem 0.375rem',
	borderRadius: '1.0625rem',
	border: `solid 0.0625rem ${theme.palette.grey[300]}`,
	width: 'fit-content',
}))

export { CoachOverviewActiveLabelBox }
